/** Main tab paths where the bottom nav is shown — keep in sync with `BottomNav`. */
export const BOTTOM_NAV_TAB_PATHS = ['/', '/orders', '/team', '/me'] as const;

export type BottomNavTabPath = (typeof BOTTOM_NAV_TAB_PATHS)[number];

export function normalizePathname(pathname: string): string {
  if (!pathname) return '/';
  const trimmed = pathname.replace(/\/+$/, '');
  return trimmed === '' ? '/' : trimmed;
}

export function isBottomNavTabPath(pathname: string): boolean {
  const path = normalizePathname(pathname);
  return (BOTTOM_NAV_TAB_PATHS as readonly string[]).includes(path);
}

/** Bottom tab bar only on authenticated main navigation pages. */
export function isBottomNavVisible(isAuthenticated: boolean, pathname: string): boolean {
  return isAuthenticated && isBottomNavTabPath(pathname);
}
